<template lang="html">
  <div class="nav_container">
    <div class="nav_ghost"></div>
    <nav>
        <div class="menu_container">
            <div class="menu_logo">
                <div class="jvdwLogo"></div>
            </div>
            <div class="menu_link">
              <router-link to="/">Home</router-link>
              <router-link to="/over">Over Ons</router-link>
              <router-link to="/portfolio">Portfolio</router-link>
              <router-link to="/contact">Contact</router-link>
            </div>
        </div>
        <div class="menu_info">
            <h1>J. van den Wijngaart Schilders - Behangers | Tel: 0297-564092 / 0297-540055</h1>
        </div>
    </nav>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css">

.mobiel_nav{

}

.nav_container{

}

.nav_ghost{
  width: 100%;
  height: 60px;
}

nav{
    top: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: fixed;
    background: #fff;
    box-shadow: 2px 2px 2px rgba(0,0,0,0.05);
    z-index: 1000;
}

nav .menu_container{
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1000px;
    width: 100%;
    height: 60px;
}

nav .menu_logo{

}

.jvdwLogo{
    width: 300px;
    height: 60px;
    background-image: url('../../assets/logo/jvdw.jpg');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
}

.ohLogo{
    width: 80px;
    height: 60px;
    background-image: url('../../assets/logo/oh_logo.png');
    background-position: center;
    background-size: 70%;
    background-repeat: no-repeat;
}

nav .menu_link{

}

nav .menu_link a{
    font-family: 'Segoe UI', sans-serif;
    font-size: 15px;
    color: #777;
    text-decoration: none;
    margin: 0 15px 0 15px;
    position: relative;
}

nav .menu_link a:after{
    position: absolute;
    background-color: #777;
    bottom: -5px;
    right: 0;
    content: ' ';
    height: 1px;
    width: 0%;
    transition: 0.3s ease;
}

nav .menu_link a:hover:after{
    left: 0;
    width: 100%;
    transition: 0.3s ease;
}

nav .menu_info{
    height: 25px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #222;
    display: none;
}

nav .menu_info h1{
    font-family: 'Roboto', sans-serif;
    font-weight: 300;
    font-size: 15px;
    color: #fff;
}

nav .router-link-exact-active{
    font-weight: 700;
    color: #222 !important;
}

nav .router-link-exact-active:after{
    content: ' ';
    background-color: #222 !important;
    width: 100% !important;
}

@media only screen and (max-width : 650px) {
  .nav_container{
    display: none;
  }

  .jvdwLogo{
      width: 40px;
      height: 40px;
      background-image: url('../../assets/logo/jvdw_logo.png');
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
  }

  .menu_link{
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
